// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1Si4E","title":"Header_title__2Wd-y","side":"Header_side__112AF"};